/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).on('click', '[data-for^="item_"]', function () {
    let id = $(this).attr('data-for');
    $(document).find('.menumb-lv2-wrapper [id^="item_"]').removeClass('active');
    $(document).find('.menumb-lv2-wrapper #' + id).addClass('active');
    $(document).find('.ss__autocomplete--target.ss__autocomplete--default').each(function () {
    const currentValue = parseInt($(this).css('top')); 
    const newValue = currentValue * 2; // Double the value - because on the second menu it needs twice the room 
    $(this).css('--header-height', newValue + 'px');
    });
});

$(document).on('click', '.menumb-lv2-wrapper .close-nav', function () {
    $('#sidebar-menu').find('[data-action="close-drawer"]').trigger('click');
});

$(document).on('click', '.menumb-lv2-wrapper .back-nav, .PageOverlay, [data-action="close-drawer"]', function () {
    $(document).find('.menumb-lv2-wrapper [id^="item_"]').removeClass('active');
    $(document).find('.ss__autocomplete--target.ss__autocomplete--default').each(function () {
        const doubledValue = parseInt($(this).css('top')); 
        const originalValue = doubledValue / 2;
        $(this).css('top', originalValue + 'px'); // Set back to original value
    });
});

$('.Header__Wrapper').hover(
    function (item){
        $(item.currentTarget).find('.MegaMenu').length > 0 && $('body').addClass('hover-main-menu');
    },
    function (){
        $('body').removeClass('hover-main-menu');
    }
);

$('[data-action="open-drawer"][aria-label="Open navigation"]').click(
    function() {
        $('body').addClass('menu-is-open');
    }
);

$('.PageOverlay').click(function(){
    $('body').hasClass('menu-is-open') && $('body').removeClass('menu-is-open');
});

$('.MegaMenu ul.Linklist').each(function(item){
    if ($(this).innerHeight() > $(this).parent().next('.MegaMenu__Item:has(".MegaMenu__PushLink")').innerHeight()) {
        $(this).css('column-count', 2);
    }
});

function updateImage() {
    const initImages = document.querySelectorAll(".image-item-reload");
    initImages.forEach((image) => {
        image.setAttribute('srcset', image.getAttribute('data-srcset'));
    });
}
document.addEventListener("DOMContentLoaded", function() {
    if (document.body.classList.contains('template-index')) {
        window.addEventListener("scroll", function () {
            updateImage();
        });
    } else {
        updateImage();
    }
});
